import { useState } from "react";
import { faqItems } from "@/mocks/homeContent";

function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="flex flex-col items-start">
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700 ring-1 ring-primary-200">
                <i className="ri-question-line"></i>
                常见问题
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                关于换新地址与历史版本
              </h2>
              <p className="mt-3 text-sm leading-6 text-foreground-600">
                集中回答最常被问到的几类问题，帮你快速搞清楚旧网址、换新地址与发布历史的用法。
              </p>
              <a
                href="#subscribe"
                className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 px-4 py-2 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-50"
              >
                <i className="ri-customer-service-2-line"></i>
                还有疑问？订阅最新动态
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <ul className="space-y-3">
              {faqItems.map((item, idx) => {
                const open = openIdx === idx;
                return (
                  <li
                    key={idx}
                    className={`overflow-hidden rounded-xl border transition-colors ${
                      open ? "border-primary-200 bg-primary-50/40" : "border-background-200 bg-background-100"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? -1 : idx)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {item.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-transform ${
                          open ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        <i className="ri-arrow-down-s-line"></i>
                      </span>
                    </button>
                    {open && (
                      <div className="px-5 pb-5">
                        <p className="text-sm leading-6 text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Faq;